import { Component } from '@angular/core';

@Component({
    selector: 'global-app-promo',
    templateUrl: './rewards-hub.component.html',
    styleUrls: ['./rewards-hub.component.scss'],
    standalone: false
})
export class RewardsHubComponent {}
